import { styled } from '@/stitches.config';
import { ReactComponent as HelixLogo } from '@assets/helix.svg';
import { Box } from '@base-app';

export const StyledHeaderContainer = styled(Box, {
  borderBottom: '$borderWidths$1 solid $seafoam',
});

export const StyledHeader = styled('header', {
  display: 'flex',
  maxWidth: '$layoutMaxWidth',
  margin: 'auto',
  verticalAlign: 'baseline',
  justifyContent: 'space-between',
  padding: '$layoutPadding',
  textAlign: 'right',
  alignItems: 'center',
});

export const StyledLogo = styled(HelixLogo, { display: 'block' });
